export enum CampaignTypeEnum {
  General = 1,
  Company = 2,
}
